const { useState, useEffect } = require("react");

const AdminImage = ({
  alt = "empty",
  src,
  width,
  height,
  size,
  className,
  style,
  emptyRatio = "1 / 1",
  ...props
}) => {
  const [error, setError] = useState(src ? false : true);
  // useEffect(() => {
  //   const img = new Image();
  //   img.src = src;
  //   img.onload = () => setError(false);
  //   img.onerror = () => {
  //     setError(true);
  //   };
  // }, [src]);

  return error ? (
    <div
      className={className}
      style={{
        width: width ? width : size,
        //         height: height ? height : size,
        aspectRatio: emptyRatio,
        background: "white",
        borderWidth: "1px",
        borderColor: "gray",
        borderStyle: "solid",
        ...style,
      }}
      {...props}
      {...props.error}
    ></div>
  ) : (
    <img
      src={src}
      className={className}
      style={{
        width: width ? width : size,
        height: height ? height : size,
        ...style,
      }}
      alt={alt}
      {...props}
      {...props.success}
      onError={() => setError(true)}
    />
  );
};

export default AdminImage;
